import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import PriceSeasonColorDot from '../tag/price-season-color-dot/PriceSeasonColorDot'
import { SeasonEnum } from '../../../../../../../../lib/graphql'

const HouseSeasonalBusynessCalendarHeader = () => {
  return (
    <div className={s.legend}>
      <div>
        <PriceSeasonColorDot season={SeasonEnum.HIGH} />
        <FormattedMessage
          defaultMessage='Haute saison'
          id='ui.HouseSeasonalBusynessCalendarHeader.highSeason'
        />
      </div>
      <div>
        <PriceSeasonColorDot season={SeasonEnum.MEDIUM} />
        <FormattedMessage
          defaultMessage='Moyenne saison'
          id='ui.HouseSeasonalBusynessCalendarHeader.mediumSeason'
        />
      </div>
      <div>
        <PriceSeasonColorDot season={SeasonEnum.LOW} />
        <FormattedMessage
          defaultMessage='Basse saison'
          id='ui.HouseSeasonalBusynessCalendarHeader.lowSeason'
        />
      </div>
    </div>
  )
}

export default HouseSeasonalBusynessCalendarHeader
